var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "u-uploadSingle" },
    [
      _c(
        "el-upload",
        _vm._b(
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            staticClass: "u-upload",
            attrs: {
              drag: "",
              action: "",
              "auto-upload": false,
              "show-file-list": false,
              accept: _vm.accept,
              disabled: _vm.isDisabled,
              "on-change": _vm.uploadData,
            },
          },
          "el-upload",
          _vm.$attrs,
          false
        ),
        [
          _vm.fileUrl
            ? _c(
                "div",
                { staticClass: "previewItem" },
                [
                  _c("MyImage", {
                    staticClass: "img",
                    attrs: { src: _vm.fileUrl },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "actions" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "act previewBtn",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handlePictureCardPreview($event)
                            },
                          },
                        },
                        [_c("i", { staticClass: "el-icon-zoom-in" })]
                      ),
                      _vm._v(" "),
                      !_vm.isDisabled
                        ? [
                            _c("span", { staticClass: "act uploadBtn" }, [
                              _c("i", { staticClass: "el-icon-upload2" }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "act deleteBtn",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleRemove($event)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "el-icon-delete" })]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              )
            : [
                _vm.mode === "edit"
                  ? [
                      _c("i", {
                        staticClass: "el-icon-picture",
                        staticStyle: { color: "#004EA8", "font-size": "26px" },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "upload__container" }, [
                        _c("i", { staticClass: "u-upload__icon" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "u-upload__text1" }, [
                          _vm._v(_vm._s(_vm.$t("common.uploadImage"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "u-upload__text2" }, [
                        _vm._v(_vm._s(_vm.$t("common.dragImageHere"))),
                      ]),
                    ]
                  : _vm._e(),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _vm.footerText
        ? _c("div", { staticClass: "footer-text" }, [
            _vm._v("\n    " + _vm._s(_vm.footerText) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("MyImage", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.dialogImageUrl },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }